export default async () => {
    if (process.client) {
        return null
    }

    // @ts-ignore
    return await useNuxtApp().$redis()
}
